import { render, staticRenderFns } from "./DeleteConfirmation.vue?vue&type=template&id=1b32e623"
import script from "./DeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmation.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmation.vue?vue&type=style&index=0&id=1b32e623&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports